'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleKeyCommand = require('./handleKeyCommand');

var _handleKeyCommand2 = _interopRequireDefault(_handleKeyCommand);

var _handleReturn = require('./handleReturn');

var _handleReturn2 = _interopRequireDefault(_handleReturn);

var _onTab = require('./onTab');

var _onTab2 = _interopRequireDefault(_onTab);

require('./listStyles.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * TODO Should this instead be called styledText or something similar maybe?
 */
// Handlers
exports.default = function () {
    return {
        // Allows cmd+b etc to be used to style text
        handleKeyCommand: _handleKeyCommand2.default,
        // Provides editing help such as removing certain block styles on enter, or adding soft new lines.
        handleReturn: _handleReturn2.default,
        // Allows deep lists
        onTab: _onTab2.default
    };
};

// Styles


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/editingHelper/index.js
// module id = 685
// module chunks = 0